import { RG_TYPE } from "@project-rouge/rg-core";
import { V3toVector3, applyTransform, getPivot, distanceToLine, applyInverseTransform } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function calculateCornerCoreFireDoorsPositions(cornerCores, centerline, corridor) {
  const positions = [];
  for (const cornerCore of cornerCores) {
    let point;
    for (const wall of cornerCore.children.filter((c) => c.type === RG_TYPE.Wall)) {
      const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
      if (door) {
        const testPoint = V3toVector3(applyTransform(applyTransform(getPivot([0.5, 0, 0.5], door), wall), cornerCore));
        const { closest, distance } = distanceToLine(testPoint, centerline);
        if (distance < corridor.size[2]) {
          point = closest;
          break;
        }
      }
    }
    if (!point)
      continue;
    const d1 = point.distanceToSquared(new Vector3(...centerline[0]));
    const d2 = point.distanceToSquared(new Vector3(...centerline[1]));
    let offset = 0;
    if (d1 > d2)
      offset = -2;
    else
      offset = 2;
    const pos = applyInverseTransform(point.toArray(), corridor);
    pos[0] += offset;
    positions.push(pos);
  }
  return positions;
}
export {
  calculateCornerCoreFireDoorsPositions
};
//# sourceMappingURL=index114.js.map
